module.exports = "/app/themes/skideal/dist/images/snowflake.gif?2ffb1eba5bba4491ce9563b138bc6f98";